// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__tH1Cn","copy":"header_copy__A0wtQ","subheader":"header_subheader__HIfBn"};